import React, { FC } from 'react';
import styled from 'styled-components';
import { TemplateInsightGroupBy } from 'api/template-insight';
import { Filter } from 'components/molecules/filters/types';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { useTranslate } from 'hooks/use-translation';
import { useTemplateInsightQuery } from 'queries/template-insight';
import { AutoHeightTable } from '../auto-heigh-table';
import { Wrapper } from '../components';
import {
  DefaultEmptyTable,
  DelayedEmptyChart,
  EarlyEmptyChart,
} from '../empty-state';
import {
  useBarChartForPhases,
  usePhaseReports,
  usePhaseTable,
} from '../phases/phase';
import { TemplateInsightBaseChart } from '../template-insight-base-chart';

const ChartWrapper = styled.div`
  display: flex;
  gap: var(--spacing-05);

  > * {
    width: 100%;
  }
`;

interface Props {
  range: DateRange;
  filter: Filter;
}

export const AllPhase: FC<Props> = ({ range, filter }) => {
  const translate = useTranslate();
  const { data: templateInsight, isLoading } = useTemplateInsightQuery({
    range,
    groupBy: TemplateInsightGroupBy.Phases,
    filter,
  });
  const phaseReport = usePhaseReports({ templateInsight });
  const { completedEarlyPhaseOptions, delayedPhaseOptions } =
    useBarChartForPhases(phaseReport);
  const { tableColumn, tableData } = usePhaseTable({ phaseReport });

  return (
    <Wrapper>
      <ChartWrapper>
        <TemplateInsightBaseChart
          chartOption={delayedPhaseOptions}
          title={translate(
            'reports.template_insight.overview.phases.delayed.chart.title',
          )}
          tooltip={translate(
            'reports.template_insight.overview.phases.delayed.chart.description',
          )}
          renderEmpty={DelayedEmptyChart}
          isLoading={isLoading}
        />
        <TemplateInsightBaseChart
          chartOption={completedEarlyPhaseOptions}
          title={translate(
            'reports.template_insight.overview.phases.early.chart.title',
          )}
          tooltip={translate(
            'reports.template_insight.overview.phases.early.chart.description',
          )}
          renderEmpty={EarlyEmptyChart}
          isLoading={isLoading}
        />
      </ChartWrapper>
      <AutoHeightTable
        dataSource={tableData}
        columns={tableColumn}
        titleLabel={translate(
          'reports.template_insight.overview.phases.table.title',
        )}
        isLoading={isLoading}
        renderEmpty={() =>
          DefaultEmptyTable({ noDataKey: 'report.table.empty.overview.phases' })
        }
      />
    </Wrapper>
  );
};
